var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z",
    fill: "#EF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2444 14.12L14.1244 12L16.2444 9.88C17.6044 8.445 15.5594 6.395 14.1244 7.76L12.0044 9.88L9.88439 7.76C9.29939 7.175 8.34939 7.175 7.76439 7.76C7.17939 8.345 7.17939 9.295 7.76439 9.88L9.87939 12L7.75939 14.12C6.39939 15.555 8.44439 17.605 9.87939 16.24L11.9994 14.12L14.1194 16.24C15.5544 17.6 17.6044 15.56 16.2444 14.12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingRejected);
export default __webpack_public_path__ + "static/media/onboarding-rejected.48765858.svg";
export { ForwardRef as ReactComponent };